/**
 * Manages global drag state
 */

import * as actionTypes from "../actions/actionTypes";

export enum DragEntities {
  GALLERY_ITEM = "GALLERY_ITEM",
  KIT_NAV_SECTION = "KIT_NAV_SECTION",
  KIT_NAV_HEADING = "KIT_NAV_HEADING",
}

export type DraggingReducerState = {
  entity: DragEntities | undefined;
};

export default function dragging(state: DraggingReducerState = { entity: undefined }, action) {
  switch (action.type) {
    case actionTypes.SET_DRAGGING_ENTITY:
      return {
        ...state,
        entity: action.entity || undefined,
      };
    default:
      return state;
  }
}
